import { useMemo } from 'react';
import MultiSelectDropdown, {
    MultiSelectDropdownProps,
    MultiSelectOption,
} from 'domains/core/components/MultiSelectDropdown';

export type Props<T extends string> = Omit<MultiSelectDropdownProps<T>, 'options'> & {
    options: MultiSelectOption<T>[];
    /** Items to derive per-status counts from. Each item may have a `status` field. */
    items: unknown[];
};

const StatusFilterDropdown = <T extends string>({ options, items, ...rest }: Props<T>) => {
    const statusCounts = useMemo(
        () =>
            items.reduce<Record<string, number>>((acc, item) => {
                const status =
                    item && typeof item === 'object' && 'status' in item
                        ? (item as { status?: string }).status
                        : undefined;
                if (status) acc[status] = (acc[status] ?? 0) + 1;
                return acc;
            }, {}),
        [items]
    );

    const optionsWithCounts = useMemo(() => options.map((o) => ({ ...o, count: statusCounts[o.value] })), [
        options,
        statusCounts,
    ]);

    return <MultiSelectDropdown options={optionsWithCounts} {...rest} />;
};

export default StatusFilterDropdown;
